import { render, staticRenderFns } from "./complaintAdd.vue?vue&type=template&id=f2f363ac&scoped=true&"
import script from "./complaintAdd.vue?vue&type=script&lang=js&"
export * from "./complaintAdd.vue?vue&type=script&lang=js&"
import style0 from "./complaintAdd.vue?vue&type=style&index=0&id=f2f363ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f363ac",
  null
  
)

export default component.exports